module.exports = __webpack_public_path__ + "img/1-1.28280d76.jpg";